module.exports = __webpack_public_path__ + "static/media/small_girl.3401ce70.svg";